/**
 * appChunks — lazy split points for the CEL-1086 auth-first bundle split.
 *
 * fromAppCore / fromAdminCore lazy-load a NAMED export out of the chunk
 * modules (src/AppCore.js / src/AdminCore.js) through lazyWithReload, which
 * adds the post-deploy stale-chunk auto-reload guard.
 *
 * GlobalLayout and NewChatPage are defined HERE (module level, single
 * instance) because they're shared by App.js AND the route shells
 * (RootRoute / MarketingRoute) — one stable lazy identity everywhere.
 */
import { lazyWithReload } from './utils/lazyRetry';

export const fromAppCore = (name) =>
  lazyWithReload(() => import('./AppCore').then((m) => ({ default: m[name] })));

export const fromAdminCore = (name) =>
  lazyWithReload(() => import('./AdminCore').then((m) => ({ default: m[name] })));

export const GlobalLayout = fromAppCore('GlobalLayout');
export const NewChatPage = fromAppCore('NewChatPage');
